import React from 'react';
import { Spinner } from '@cp-shared-15/frontend-ui';
import { Container } from './Container';

export const StateLoading = () => {
    return (
        <Container>
            <Spinner center />
        </Container>
    );
};
